import { render, staticRenderFns } from "./FulfillmentMibox.vue?vue&type=template&id=ca0137c2"
import script from "./FulfillmentMibox.vue?vue&type=script&lang=js"
export * from "./FulfillmentMibox.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentMibox.vue?vue&type=style&index=0&id=ca0137c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports